import { Component, OnInit } from '@angular/core';
import { ResponseNotificationService } from 'src/app/modules/shared/services/response-notification/response-notification.service';

@Component({
  selector: 'app-response-notificaion',
  template: `
    <div class="notification" [ngClass]="{'show': message}">
      <p class="message" [ngClass]="{'text-danger': danger}">{{ message?.message }}</p>
    </div>
  `,
  styleUrls: ['./response-notificaion.component.scss'],
})
export class ResponseNotificaionComponent implements OnInit {
  message: { message: string, danger: boolean } | null = null;
  danger: boolean = false;

  constructor(
    private responseNotificaitonService: ResponseNotificationService
  ) { }

  ngOnInit() {
    this.responseNotificaitonService.message$.subscribe(message => {
      this.message = message;
      this.danger = message?.danger || false;
    });
  }
}
